import React, { useRef, useImperativeHandle, forwardRef, useState } from 'react';
import { gsap } from 'gsap';

const PageTransition = forwardRef((props, ref) => {
  const overlayRef = useRef(null);
  const accentRef = useRef(null);
  const [isAnimating, setIsAnimating] = useState(false);

  useImperativeHandle(ref, () => ({
    triggerTransition: (targetId, scrollCallback) => {
      if (isAnimating) return;
      
      setIsAnimating(true);
      
      // Check if mobile
      const isMobile = window.innerWidth < 768;
      const duration = isMobile ? 0.3 : 0.5;
      const holdDuration = 0.1;

      const tl = gsap.timeline({
        onComplete: () => {
          setIsAnimating(false);
        }
      });

      // PHASE 1: ENTER (wipe in from left)
      tl.set([overlayRef.current, accentRef.current], {
        scaleX: 0,
        opacity: 1,
        visibility: 'visible',
        transformOrigin: 'left center',
        pointerEvents: 'auto'
      })
      .to(overlayRef.current, {
        scaleX: 1,
        duration: duration,
        ease: 'power2.inOut'
      })
      .to(accentRef.current, {
        scaleX: 1,
        duration: duration,
        ease: 'power2.inOut'
      }, `-=${duration - 0.05}`) // 0.05s delay for accent

      // PHASE 2: HOLD + SCROLL
      .add(() => {
        if (scrollCallback) {
          scrollCallback(targetId);
        }
      }, `+=${holdDuration}`)

      // PHASE 3: EXIT (wipe out to right)
      .set([overlayRef.current, accentRef.current], {
        transformOrigin: 'right center'
      })
      .to(overlayRef.current, {
        scaleX: 0,
        duration: duration,
        ease: 'power2.inOut'
      })
      .to(accentRef.current, {
        scaleX: 0,
        duration: duration,
        ease: 'power2.inOut'
      }, `-=${duration - 0.05}`)
      .set([overlayRef.current, accentRef.current], {
        opacity: 0,
        visibility: 'hidden',
        pointerEvents: 'none'
      });
    }
  }));

  return (
    <>
      {/* Main Black Overlay */}
      <div
        ref={overlayRef}
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: '#0a0a0a',
          zIndex: 9999,
          pointerEvents: 'none',
          transformOrigin: 'left center',
          transform: 'scaleX(0)',
          opacity: 0,
          visibility: 'hidden',
        }}
      />

      {/* Yellow Accent Stripe */}
      <div
        ref={accentRef}
        style={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          width: '100%',
          height: '6px',
          backgroundColor: '#FFD700',
          zIndex: 10000,
          pointerEvents: 'none',
          transformOrigin: 'left center',
          transform: 'scaleX(0)',
          opacity: 0,
          visibility: 'hidden',
        }}
      />
    </>
  );
});

PageTransition.displayName = 'PageTransition';

export default PageTransition;
